var map = {
	"./project/album.svg": "851e",
	"./project/close.svg": "b44b",
	"./project/fireworks-2.gif": "2f5c",
	"./project/ndp-tag-logo.png": "2e74",
	"./project/next.svg": "f0df",
	"./project/play-icon.svg": "7a13",
	"./project/previous.svg": "5021",
	"./project/solar-eclipse-header-desktop.jpg": "e884",
	"./project/solar-eclipse-header.jpg": "7b56",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";